export enum CTARole {
  MANAGER = 'manager',
  COACH = 'coach',
  ADMIN = 'admin',
}
